var render = function () {
var _obj, _obj$1;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[_vm.$style.root, ( _obj = {}, _obj[_vm.$style.square] = _vm.square, _obj )],style:(_vm.rootStyle)},[_c('div',{class:[_vm.$style.content, ( _obj$1 = {}, _obj$1[_vm.$style.absolute] = _vm.square || _vm.ratio > 0, _obj$1 )]},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }